var _style, _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiropay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Original",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.4 37",
    style: {
      enableBackground: "new 0 0 33.4 37"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#1F3A6A;}\n\t.st1{fill:#5DC4E9;}\n ")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 37,
    width: 33.4,
    x: -73.1,
    y: 47.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.7,10.7 23.7,10.7 23.7,11.5 26.1,11.5 32,35.9 1.4,35.9 7.3,11.5 9.7,11.5 9.7,10.7 6.7,10.7 0,37  33.4,37  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.6,0H10.9c-0.7,0-1.3,0.6-1.3,1.3v11.5h1.1V1.3c0-0.1,0.1-0.2,0.2-0.2h2.4v8.3H11l3.1,3.3h5.1l3.1-3.3h-2.2 V1.1h2.4c0.1,0,0.2,0.1,0.2,0.2v11.5h1.1V1.3C23.9,0.6,23.3,0,22.6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.3,26.9h4.9c0.3,0,0.6-0.2,0.6-0.5c0,0,0,0,0,0l-0.2-3.2c0-0.3-0.3-0.6-0.6-0.6h-4.4 c-0.3,0-0.6,0.3-0.6,0.6l-0.2,3.2C13.7,26.7,13.9,26.9,14.3,26.9C14.2,26.9,14.2,26.9,14.3,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.8,22.5H7.4c-0.3,0-0.6,0.3-0.7,0.6L6,26.4c-0.1,0.3,0.1,0.5,0.3,0.6c0,0,0.1,0,0.1,0h5 c0.3,0,0.6-0.3,0.6-0.6l0.3-3.2C12.4,22.8,12.2,22.6,11.8,22.5C11.8,22.5,11.8,22.5,11.8,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,21.2H19c0.2,0,0.4-0.2,0.4-0.4c0,0,0,0,0,0l-0.2-2.6c0-0.3-0.2-0.5-0.5-0.5h-4.1c-0.3,0-0.5,0.2-0.5,0.5 L14,20.8C14,21,14.2,21.2,14.5,21.2C14.4,21.2,14.4,21.2,14.5,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4,17.7H8.2c-0.3,0-0.5,0.2-0.6,0.5l-0.5,2.6c-0.1,0.2,0.1,0.4,0.3,0.5c0,0,0.1,0,0.1,0h4.6 c0.3,0,0.5-0.2,0.5-0.5l0.2-2.6C12.8,18,12.6,17.7,12.4,17.7C12.4,17.7,12.4,17.7,12.4,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.9,21.2c0.2,0,0.4-0.1,0.4-0.4c0,0,0-0.1,0-0.1l-0.5-2.6c-0.1-0.3-0.3-0.5-0.6-0.5h-4.1 c-0.2,0-0.4,0.2-0.4,0.4c0,0,0,0,0,0.1l0.2,2.6c0,0.3,0.2,0.5,0.5,0.5L25.9,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,16.6h4.1c0.2,0,0.4-0.2,0.4-0.4c0,0,0,0,0,0l-0.1-2c0-0.2-0.2-0.4-0.4-0.4h-3.8c-0.2,0-0.4,0.2-0.4,0.4 l-0.1,2C14.2,16.4,14.4,16.6,14.7,16.6C14.6,16.6,14.6,16.6,14.7,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.1,16.6c0.2,0,0.3-0.1,0.3-0.3c0,0,0-0.1,0-0.1l-0.4-2c-0.1-0.2-0.3-0.4-0.5-0.4h-3.8 c-0.2,0-0.4,0.2-0.4,0.4c0,0,0,0,0,0l0.2,2c0,0.2,0.2,0.4,0.5,0.4H25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.8,13.8H8.9c-0.2,0-0.4,0.2-0.5,0.4l-0.4,2c0,0.2,0.1,0.4,0.2,0.4c0,0,0.1,0,0.1,0h4.2 c0.2,0,0.4-0.2,0.5-0.4l0.2-2C13.2,14,13,13.8,12.8,13.8C12.8,13.8,12.8,13.8,12.8,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.9,26.9c0.3,0,0.5-0.2,0.5-0.4c0,0,0-0.1,0-0.1l-0.7-3.2c-0.1-0.3-0.4-0.6-0.7-0.6h-4.4 c-0.3,0-0.5,0.2-0.5,0.5c0,0,0,0,0,0.1l0.3,3.2c0,0.3,0.3,0.6,0.6,0.6H26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,28.4h-4.8c-0.4,0-0.7,0.3-0.8,0.7l-0.2,4.1c0,0.4,0.3,0.7,0.6,0.7c0,0,0,0,0.1,0h5.5 c0.4,0,0.7-0.3,0.7-0.7c0,0,0,0,0-0.1l-0.2-4.1C19.8,28.7,19.5,28.4,19.1,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.2,28.4H6.3c-0.4,0-0.8,0.3-0.9,0.7l-0.8,4.1c-0.1,0.3,0.1,0.6,0.4,0.7c0.1,0,0.1,0,0.2,0h5.5 c0.4,0,0.7-0.3,0.8-0.7l0.3-4.1C11.8,28.8,11.6,28.4,11.2,28.4C11.2,28.4,11.2,28.4,11.2,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,29.1c-0.1-0.4-0.4-0.7-0.9-0.7h-4.8c-0.4,0-0.7,0.3-0.7,0.6c0,0,0,0.1,0,0.1l0.3,4.1 c0,0.4,0.4,0.7,0.8,0.7h5.5c0.3,0,0.6-0.2,0.6-0.5c0-0.1,0-0.1,0-0.2L28,29.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiropay);
export default __webpack_public_path__ + "static/media/Giropay.9a3f0c4a904e9038ebbc3a84791e3f57.svg";
export { ForwardRef as ReactComponent };